import React from 'react';
import { ToolType } from '../utils/types';
import Sidebar from './sidebar/Sidebar';

interface GatewaySidebarProps {
  darkMode: boolean;
  selectedTool: ToolType;
  collapsed: boolean;
  loadingProjects: boolean;

  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onToolSelect: (tool: ToolType) => void;
  onToggleCollapse: () => void;
}

const GatewaySidebar = ({
  darkMode,
  selectedTool,
  collapsed,
  loadingProjects,
  onClickHandler,
  onToolSelect,
  onToggleCollapse,
}: GatewaySidebarProps) => {
  return (
    <Sidebar
      selectedTool={selectedTool}
      collapsed={collapsed}
      onToolSelect={onToolSelect}
      onClickHandler={onClickHandler}
      onToggleCollapse={onToggleCollapse}
    />
  );
};

export default GatewaySidebar;
